// extracted by mini-css-extract-plugin
export default {"heading":"MessageDialog_heading__CyRD2","subHeading":"MessageDialog_subHeading__ixHG9","button":"MessageDialog_button__qucWu","primary":"MessageDialog_primary__r6AWs"};